import React from 'react';
import sent from '../assets/sent.svg'
import {Link} from 'react-router-dom'
import { Zoom } from 'react-reveal';

const SuccessPage = () => {
  return (
    <section className='bg-black min-h-screen'>
      <Zoom>
    <div className="container mx-auto pt-40 lg:pt-32 text-center">
  <img src={sent} alt=""  className=' w-2/12 ml-40 md:ml-80 lg:w-24 lg:ml-[700px] lg:mb-5'/>
      <h2 className="lg:text-3xl text-xl font-bold text-orange-default mb-4">Message Sent Successfully!</h2>
      <p className="lg:text-xl lg:w-12/12 lg:ml-24 w-10/12  ml-8 text-white ">
        Thank you for contacting us. We will get back to you soon.
      </p>
      <Link to='/'>
      <button type='submit' className='bg-orange-default rounded py-1 px-2 mt-3 font-bold text-white lg:py-2 lg:px-3 lg:mt-5'>Back to home</button>
      </Link>
      
    </div>
    </Zoom>
    </section>
  );
};

export default SuccessPage;
